
import homebtn from './homebtn.vue';

export default (Vue) => {
  Vue.component("homebtn", homebtn) // 前者必须是字符串格式
}



// WEBPACK FOOTER //
// ./src/page/components/components.js